export default {"src":"/_next/static/media/Circle4.f63bb2fc.svg","height":567,"width":570,"blurWidth":0,"blurHeight":0};